// extracted by mini-css-extract-plugin
module.exports = {"input":"input--NIH5w","editing":"editing--BXpJE","enter":"enter--twGBS","delete":"delete--6InaX"};